if (!customElements.get('yrp-gallery-dots')) {
  customElements.define('yrp-gallery-dots', class extends HTMLElement {
    connectedCallback() {
      this.list = this.closest('slider-component')?.querySelector('.product__media-list');
      if (!this.list) return;
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.onClick = (event) => {
        const button = event.target.closest('button[data-media-id]');
        if (!button) return;
        const item = this.items.find(item => item.dataset.mediaId === button.dataset.mediaId);
        if (!item) return;
        const viewport = this.list.getBoundingClientRect();
        const rect = item.getBoundingClientRect();
        this.list.scrollTo({
          left: this.list.scrollLeft + rect.left - viewport.left - (viewport.width - rect.width) / 2,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      this.list.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('click', this.onClick);
      this.resizeObserver = new ResizeObserver(() => this.rebuild());
      this.resizeObserver.observe(this.list);
      this.mutationObserver = new MutationObserver(() => this.rebuild());
      this.mutationObserver.observe(this.list, { childList: true, attributes: true, subtree: true, attributeFilter: ['class', 'style', 'hidden'] });
      this.rebuild();
    }
    rebuild() {
      this.items = Array.from(this.list.children).filter(item => item.matches('.product__media-item') && getComputedStyle(item).display !== 'none');
      this.hidden = this.items.length < 2 || !matchMedia('(max-width: 749px)').matches;
      const signature = this.items.map(item => item.dataset.mediaId).join('|');
      if (signature !== this.signature) {
        this.signature = signature;
        this.replaceChildren(...this.items.map((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.mediaId = item.dataset.mediaId;
          button.setAttribute('aria-label', (item.querySelector('img')?.alt || this.getAttribute('aria-label') || '') + ' (' + (index + 1) + '/' + this.items.length + ')');
          return button;
        }));
      }
      this.update();
    }
    update() {
      if (this.hidden || !this.items.length) return;
      const viewport = this.list.getBoundingClientRect();
      const center = viewport.left + viewport.width / 2;
      let active = 0;
      let distance = Infinity;
      this.items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const delta = Math.abs(rect.left + rect.width / 2 - center);
        if (delta < distance) { active = index; distance = delta; }
      });
      Array.from(this.children).forEach((button, index) => button.setAttribute('aria-current', index === active ? 'true' : 'false'));
    }
    disconnectedCallback() {
      this.list?.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('click', this.onClick);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
